import { CircularProgress } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';
import classes from '../Scanit.module.css';

const ScanitAccuracy = (props) => {
	const { isLoading, scanitData } = props;

	const [monthYear, setMonthYear] = useState('');

	const formatDate = (dateToTransform) => {
		var date = new Date(dateToTransform);

		var monthNames = [
			'Enero',
			'Febrero',
			'Marzo',
			'Abril',
			'Mayo',
			'Junio',
			'Julio',
			'Agosto',
			'Septiembre',
			'Octubre',
			'Noviembre',
			'Diciembre',
		];

		//var day = date.getUTCDate();
		var monthIndex = date.getUTCMonth();
		var year = date.getUTCFullYear();

		return monthNames[monthIndex] + ' ' + year;
	};

	useEffect(() => {
		if (isLoading === false) {
			setMonthYear(formatDate(scanitData.scanit.initialDate));
		}
	}, [isLoading, scanitData]);

	return (
		<React.Fragment>
			<div className={classes.headerTitle}>
				Accuracy Report
				<br></br>
				(Gastos Aprobados)
			</div>

			<div className={classes.date}>{monthYear}</div>
			{isLoading ? (
				<CircularProgress />
			) : (
				<div>
					<div className={classes.scanitAccuracy}>
						Monto-Fecha-Proveedor:{' '}
						<NumberFormat
							value={scanitData.scanit.merchantDateBillingAccuracy * 100}
							displayType={'text'}
							decimalScale={2}
							suffix={'%'}
						/>
					</div>
					<br></br>
					<div className={classes.scanitAccuracy}>
						Todos los Campos:{' '}
						<NumberFormat value={scanitData.scanit.totalAccuracy * 100} displayType={'text'} decimalScale={2} suffix={'%'} />
					</div>

					<br></br>
				</div>
			)}
		</React.Fragment>
	);
};

export default React.memo(ScanitAccuracy);
